import { defineComponent as _defineComponent } from 'vue'
import { useI18n } from '@/composables/i18n';
import { nullStandardAlert, StandardAlert } from '@/models/standardAlert';
import DetailAccordion from '@/components/DetailAccordion.vue';
import DisplayInput from '@/components/inputs/DisplayInput.vue';
import DisplayDatepicker from '@/components/inputs/DisplayDatepicker.vue';
import DisplayTaginput from '@/components/inputs/DisplayTaginput.vue';
import { computed, onMounted, ref } from 'vue';
import { isEmpty, isNil } from '@/utils/misc';
import { translateFilterTimeAxisSpanEnum } from '@/utils/i18n';
import {
  formatWithUnit,
  translateKpi,
  translateOperator,
  translateSeverity,
  translateStandardAlertStatus,
  translateVariable,
} from '@/utils/alerts';
import { standardAlertsService } from '@/services/standardAlerts.service';


export default /*#__PURE__*/_defineComponent({
  __name: 'StandardAlertDetailModal',
  props: {
    standardAlertId: null
  },
  emits: ['close'],
  setup(__props: any, { emit }) {

const props = __props as {
  standardAlertId: number;
};





const standardAlert = ref<StandardAlert>(nullStandardAlert);
const isLoading = ref(true);

onMounted(async () => {
  try {
    standardAlert.value = await standardAlertsService.getById(props.standardAlertId);
  } finally {
    isLoading.value = false;
  }
});

const hasVariable = computed<boolean>(
  () => !isNil(standardAlert.value?.variable),
);

const hasSources = computed<boolean>(
  () => !isEmpty(standardAlert.value?.eventSources),
);

const hasCodes = computed<boolean>(
  () => !isEmpty(standardAlert.value?.eventCodes),
);

const { t } = useI18n();

return { __sfc: true,props, emit, standardAlert, isLoading, hasVariable, hasSources, hasCodes, t, DetailAccordion, DisplayInput, DisplayDatepicker, DisplayTaginput, translateFilterTimeAxisSpanEnum, formatWithUnit, translateKpi, translateOperator, translateSeverity, translateStandardAlertStatus, translateVariable }
}

})